export default __webpack_public_path__ + "static/media/tool.51c7f39f.gif";